import { render, staticRenderFns } from "./DeleteTableButton.vue?vue&type=template&id=280a591e&"
import script from "./DeleteTableButton.vue?vue&type=script&lang=js&"
export * from "./DeleteTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports